// DogIcon.tsx
import React, {FC} from 'react';
import dogs from '../../assets/images/icon-page/dogs.png';


const DogIcon: FC<{ size?: number | string; alt?: string }> = ({size = 24, alt = 'Dog Icon'}) => {
    return (
        <img
            src={dogs}
            alt={alt}
            style={{width: size, height: size, display: 'block'}}
        />
    );
};

export default DogIcon;
